import { render, staticRenderFns } from "./profileDetail.vue?vue&type=template&id=6d7c7b86&scoped=true"
import script from "./profileDetail.vue?vue&type=script&lang=js"
export * from "./profileDetail.vue?vue&type=script&lang=js"
import style0 from "./profileDetail.vue?vue&type=style&index=0&id=6d7c7b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7c7b86",
  null
  
)

export default component.exports